<div class="cta-back">
    <a href="#" [ngClass]="'cta-theme-'+theme">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 13L19 13V11.5L5.5 11.5V13Z" fill="#E6E8F1" />
            <path d="M5.44561 13L12 6.5H10.1088L4.5 12.0627L5.44561 13Z" fill="#E6E8F1" />
            <path d="M5.45157 11.5L12 18H10.1105L4.5 12.4068L5.45157 11.5Z" fill="#E6E8F1" />
        </svg>
        {{text}}
    </a>
</div>